

import {Component, Prop} from "vue-property-decorator";
import {UserLevel} from "shared/entities/user";
import * as icons from "@fortawesome/free-solid-svg-icons";
import AuthMixin from "@/mixins/auth.mixin";

interface ManagementLink {
    to: string;
    title: string;
    icon: string;
    minLevel: UserLevel;
}

// Mirrors the v-if gates on the v1 tiles above, one entry per tile, same order.
const LINKS: ManagementLink[] = [
    {to: "/report/training-completion", title: "Lookup Results",                icon: "faEnvelopeOpenText", minLevel: UserLevel.GM},
    {to: "/manage/users",               title: "Manage Users",                  icon: "faUser",             minLevel: UserLevel.GM},
    {to: "/manage/salesapproval",       title: "Approve Sales",                 icon: "faCashRegister",     minLevel: UserLevel.GM},
    {to: "/manage/sales-view",          title: "View Sales",                    icon: "faCoins",            minLevel: UserLevel.GM},
    {to: "/manage/tp-sales",            title: "Touch Point",                   icon: "faFire",             minLevel: UserLevel.GM},
    {to: "/manage/materials",           title: "Manage Training Materials",     icon: "faEnvelope",         minLevel: UserLevel.Admin},
    {to: "/manage/salesreports",        title: "Sales Reports",                 icon: "faMoneyBill",        minLevel: UserLevel.Admin},
    {to: "/manage/brand-manuals",       title: "Manage Brand Standards Manual", icon: "faBook",             minLevel: UserLevel.Admin},
    {to: "/manage/important-links",     title: "Manage Important Links",        icon: "faExternalLinkAlt",  minLevel: UserLevel.Admin},
    {to: "/manage/settings",            title: "Settings",                      icon: "faCog",              minLevel: UserLevel.Admin},
    {to: "/manage/alerts",              title: "Alerts",                        icon: "faBell",             minLevel: UserLevel.Admin},
];

@Component({})
export default class ManagementSection extends AuthMixin {
    @Prop({default: false})
    v2!: boolean;

    UserLevel = UserLevel;
    icons = icons;

    get visibleLinks(): ManagementLink[] {
        if (!this.user) return [];
        return LINKS.filter(l => this.user.level >= l.minLevel);
    }

    comingSoon($event: MouseEvent) {
        $event.stopPropagation();
        alert("Coming Soon.");
    }
}

